import { useEffect, useState } from 'react';
import './App.css';
import { getVideo } from './firebase';
import logo from "./scalefasterlogo.png";
import { Spin, Alert } from "antd";

function App() {
  const [dimension, setDimension] = useState({
    width: 1920,
    height: 1080
  })

  const [playerDimension, setPlayerDimension] = useState({
    width: "800px",
    height: "500px"
  })

  const [finalVideo, setFinalVideo] = useState("")
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  useEffect(() => {

    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search);
    const inputProps = {};
    params.forEach((value, key) => {
      inputProps[key] = value;
    });
    const videoType = url.searchParams.get('videoType');

    getVideo({
      inputProps,
      videoType,
      key: '38CD16FC18759'
    }).then(res => {
      console.log("The result is", res)
      const url = res.data
      console.log("The url ", url)
      setFinalVideo(url)
    })

  }, []);


  return (
    <div style={{ display: "flex", flexDirection: "column", paddingTop: '50px', alignItems: "center", height: "100vh", width: "100%", background: 'black' }}>
      <img src={logo} alt="Logo" style={{ marginBottom: "40px", color: 'black', width: '300px', cursor: 'pointer' }} onClick={() => window.open('https://scalefaster.io')} />
      {
        finalVideo === "" || finalVideo  === null || finalVideo === undefined?
          <Spin tip="Creating Personalized Video" size="large">
          </Spin> : <video controls preload="auto" autoPlay style={{
            width: screenWidth > 501 ? playerDimension.width : screenWidth - 10,
            backgroundColor: 'black',
            borderRadius: '10px'
          }}
            src={finalVideo} />
      }
    </div>
  );
}
export default App;